// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2cwBh","Label":"Input_Label__39X_t","InputElement":"Input_InputElement__1o_cJ","Invalid":"Input_Invalid__1Z9yj"};